import { createMuiTheme, colors } from '@material-ui/core';
import shadows from './shadows';
import typography from './typography';

const theme = createMuiTheme({
  palette: {
    background: {
      dark: '#1c1c1c',
      default: colors.common.white,
      paper: colors.common.white
    },
    primary: {
      main: '#1c1c1c'
    },
    secondary: {
      main: '#028BD2'
    },
    text: {
      primary: colors.common.white,
      secondary: '#028BD2'
    }
  },
  spacing: 10,
  shadows,
  typography
});

export default theme;
